import { Component, OnInit, OnDestroy } from '@angular/core';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';

import {
  NotificationService,
  BackendService,
  ListService,
  FieldStructure,
  TableSettings,
} from 'beyond-util';

import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { UtilServiceClient } from '../../../services/util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { IzvestajSettings } from '../prihodi-po-emisijama/izvestaj-settings.service';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';
import * as moment from 'moment';
import { RequestTypeEnum } from '../../../enums/request-type.enum';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import { ReportService } from '../../../services/report.service';
import { MontazaService } from '../../../services/montaza.service';

@Component({
  selector: 'app-izvestaj-realizacije',
  templateUrl: './izvestaj-realizacije.component.html',
  styleUrls: ['./izvestaj-realizacije.component.scss'],
})
export class IzvestajRealizacijeComponent extends IzvestajBaseComponent
  implements OnInit, OnDestroy {
  public canGenerate: boolean;

  constructor(
    protected _backendService: BackendService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService,
    protected izvestajSettings: IzvestajSettings,
    private _montazaService: MontazaService
  ) {
    super(_backendService);
    this.orderList = [];
    this.name = 'Osnovni izveštaj realizacije';
  }

  ngOnInit() {
    this.getSettings();
    this._listService.enumItemsSet.subscribe(item => {
      if (item === 'MSRR_REAL_ProgramIdEnum') {
        super.ngOnInit();
      }
    });

    const izvestajData = JSON.parse(
      JSON.stringify(this._montazaService.izvestajData)
    );
    if (izvestajData) {
      izvestajData.emisija.Naziv = izvestajData.emisija.EmisijaNaziv;
      izvestajData.emisija.Sifra = izvestajData.emisija.EmisijaSifra;
      izvestajData.emisija.Id = izvestajData.emisija.EmisijaId;
      izvestajData.emisija.ProgramId = izvestajData.program.Id;
      izvestajData.emisija.ProgramNaziv = izvestajData.program.Naziv;
    }

    this.report = {
      Datum: izvestajData ? izvestajData.datum : new Date(),
      ProgramId: izvestajData ? izvestajData.program.Id : null,
      ProgramNaziv: izvestajData ? izvestajData.program.Naziv : null,
      Emisija: izvestajData ? izvestajData.emisija : null,
      VremeEmitovanja: null,
    };
  }

  valueChanged(event: any) {
    if (event.newValue) {
      this.canGenerate = false;
      switch (event.fieldMap.fieldKey) {
        case 'Datum':
          this.report.Datum = moment(event.newValue).format(
            DEFAULT_DATE_FORMAT
          );
          break;
        case 'ProgramId':
          this.report.ProgramId = event.newValue;
          this.report.ProgramNaziv = this._listService
            .getEnum('MSRR_REAL_ProgramIdEnum')
            .find(p => p.value === event.newValue).label;
          break;
        case 'Emisija':
          this.report.Emisija = event.newValue;
          break;
      }
    }
  }

  removeMandaotory(fieldStructure: FieldStructure) {
    fieldStructure.fieldList.forEach(field => {
      if (field.fieldName === 'VremeEmitovanja' || field.fieldName === 'Emisija') {
        field.mandatory = false;
      }
    });
  }

  fetchProgrami() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .subscribe(response => {
        this._spinner.hide();
        const programi = response.ServiceData.Data;
        const parsed = this.utilService.parseEnum(programi);
        this._listService.registerEnum('MSRR_REAL_ProgramIdEnum', parsed);
        this._listService.registerEnum('MSEMI_EMI_ProgramIdEnum', parsed);
      });
  }

  refresh() {
    this.report = {
      Datum: new Date(),
      ProgramId: null,
      ProgramNaziv: null,
      Emisija: null,
      VremeEmitovanja: null,
    };
  }

  getRequestObject() {
    return {
      Datum: moment(this.report.Datum).format(DEFAULT_DATE_FORMAT),
      ProgramId: this.report.ProgramId,
      Emisija: this.report.Emisija,
      ProgramNaziv: this.report.ProgramNaziv,
      VremeEmitovanja: this.report.VremeEmitovanja,
    };
  }

  filter() {
    if (!this.report.Datum || !this.report.ProgramId) {
      return this.notificationService.notyError(
        'Niste uneli sva obavezna polja.'
      );
    }

    const entity = this.getRequestObject();
    const payload = this.reportService.getPayload(
      null,
      entity,
      FormCode.MSRR_REAL,
      ReportNameEnum.Realizacija,
      EndpointTypeEnum.Form,
      RequestTypeEnum.Post
    );

    this.reportService.getFormData(payload).subscribe(data => {
      if (data.Errors && data.Errors.length) {
        this.canGenerate = false;
        this.notificationService.notyError(data.Errors[0].ErrorMessage);
        this.orderList = [];

        return;
      } else {
        this.canGenerate = true;
        this.orderList = this.getResponseData(data);
      }
      this.documentListSource.next(this.orderList);

      if (this.orderList.length < 1) {
        this.canGenerate = false;
        this.notificationService.notyError(
          'Ne postoji ni jedna rezervacija za zadate filtere.'
        );

        return;
      }
    });
  }

  getSettings() {
    const req = this.reportService.getSettingsPayload(
      ReportNameEnum.Realizacija,
      EndpointTypeEnum.Settings,
      FormCode.MSRR_REAL
    );

    this.reportService.getSettings(req).subscribe(s => {
      this.splitDetails(s);
      this.fetchProgrami();
      this._listService.enumItemsSet.subscribe(prog => {
        this.fieldStructure = new FieldStructure(s, 'header');
        this.removeMandaotory(this.fieldStructure);
        this.settingsTable = new TableSettings(s.details[0], 'table');
        this.settingsTableSource.next(this.settingsTable);
        this._spinner.hide();
      });

      if (this._montazaService.izvestajData) {
        this.filter();
      }
    });
    this._spinner.hide();
  }

  onToolbarActionExport() {
    if (!this.orderList.length || this.canGenerate === false) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const report = {
      Header: this.getRequestObject(),
      Table: this.orderList,
    };

    const request = this.reportService.getPayload(
      null,
      report,
      FormCode.MSRR_REAL,
      ReportNameEnum.Realizacija,
      EndpointTypeEnum.Xls
    );

    this.reportService.exportToDocument(request).subscribe(data => {
      const formattedDate: string = `${moment(new Date()).format(
        'YYYY-MM-DD_HH:mm'
      )}`.replace(
        `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
        '-'
      );

      ReportService.downloadBlob(
        data,
        MimeFileType.Xlsx,
        `Osnovni_izveštaj_realizacije_${formattedDate}`
      );
    });
  }

  onToolbarActionPrint() {
    if (!this.orderList.length || this.canGenerate === false) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const report = {
      Header: this.getRequestObject(),
      Table: this.orderList,
    };

    const request = this.reportService.getPayload(
      null,
      report,
      FormCode.MSRR_REAL,
      ReportNameEnum.Realizacija,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(request).subscribe(data => {
      ReportService.openBlob(data, MimeFileType.Pdf);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-realizacije/izvestaj-realizacije.component.ts